import React, { useState, useEffect } from "react";
import { DataTable, Filter } from "../../../../components";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DriverType, OrderStatus } from "../../../../shared/enums";
import dayjs from "dayjs";
import { DATETIME_FORMAT } from "../../../../shared/constants";
import { getOrderList } from "../../../../api/order";
import { Spinner } from "react-bootstrap";
import { formatFilterToQuery } from "../../../../shared/utils";

const UserOrder = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const [filter, setFilter] = useState({});
    const [pagination, setPagination] = useState({ page: 1, pageSize: 25 });
    const [totalPages, setTotalPage] = useState(0);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const columns = [
        {
            key: "createdAt",
            label: t("CREATED_AT"),
            render: (createdAt, data) => dayjs(createdAt).format(DATETIME_FORMAT),
        },
        { key: "driverType", label: t("DRIVER_TYPE") },
        { key: "currency", label: t("CURRENCY") },
        {
            key: "total",
            label: t("TOTAL"),
            render: (amount, data) => (+(data.amount || 0) + +(data.sstAmount || 0)).toFixed(2),
        },
        { key: "status", label: t("STATUS") },
        { key: "userFullName", label: t("USER_FULL_NAME") },
        {
            key: "userPhoneNumber",
            label: t("USER_PHONE_NUMBER"),
            render: (phoneNumber, data) =>
                data.userCountryCode + data.userPhoneNumber,
        },
        { key: "driverFullName", label: t("DRIVER_FULL_NAME") },
        {
            key: "driverPhoneNumber",
            label: t("DRIVER_PHONE_NUMBER"),
            render: (phoneNumber, data) =>
                data.driverCountryCode + data.driverPhoneNumber,
        },
        { key: "refNo", label: t("REFERENCE_NO") },
    ];

    const filters = [
        { type: "datetime", label: t("FORM_DATE"), name: "fromDate" },
        { type: "datetime", label: t("TO_DATE"), name: "toDate" },
        { type: "select", label: t("STATUS"), name: "status", options: [{ label: "All", value: "" }, ...Object.entries(OrderStatus).map(([key, value]) => ({ label: t(key), value: value }))] },
        { type: "select", label: t("DRIVER_TYPE"), name: "driverType", options: [{ label: "All", value: "" }, ...Object.entries(DriverType).map(([key, value]) => ({ label: t(key), value: value }))] }
    ];

    useEffect(() => {
        getData(pagination, filter);
    }, [pagination, filter]);

    const getData = async (pagination, filter) => {
        setLoading(true);
        const response = await getOrderList({
            skip: (pagination?.page - 1) * pagination?.pageSize,
            limit: pagination?.pageSize,
            user: id,
            ...formatFilterToQuery(filter, [{ keys: ["fromDate", "toDate"], formatter: (value) => dayjs(value).format() }]),
        });
        setData(response.items);
        setTotalPage(Math.ceil(response?.pagination?.total / pagination?.pageSize));
        setLoading(false);
    };

    return (
        <>
            <Filter filters={filters} onChangeFilter={setFilter} />
            <DataTable
                columns={columns}
                data={data}
                pagination={{ ...pagination, totalPages, onChange: setPagination }}
                loading={loading}
            />
        </>
    );
};

export default UserOrder;
